import { Component, Input, OnInit } from "@angular/core";
import { DataTable, SortEvent } from "./DataTable";

@Component({
    selector: "mfDefaultSorter",
    template: `
        <a style="cursor: pointer;text-decoration: none; color: inherit" (click)="sort()" class="text-nowrap">
          <ng-content></ng-content>
          <!--
          <span *ngIf="isSortedByMeAsc" class="glyphicon glyphicon-triangle-top" aria-hidden="true"></span>
          <span *ngIf="isSortedByMeDesc" class="glyphicon glyphicon-triangle-bottom" aria-hidden="true"></span>
          -->
          @if (isSortedByMeAsc) {
            <i class="fa fa-angle-up p-1"></i>
          }
          @if (isSortedByMeDesc) {
            <i class="fa fa-angle-down p-1"></i>
          }
        </a>`,
    standalone: false
})
export class DefaultSorter implements OnInit {
    @Input("by") sortBy: string;

    isSortedByMeAsc: boolean = false;
    isSortedByMeDesc: boolean = false;

    public constructor(private mfTable: DataTable) {
        this.mfTable.setSort('loginCredentials.userId', "asc");
    }

    public ngOnInit(): void {
        this.mfTable.onSortChange.subscribe((event: SortEvent) => {
            this.isSortedByMeAsc = (event.sortBy == this.sortBy && event.sortOrder == "asc");
            this.isSortedByMeDesc = (event.sortBy == this.sortBy && event.sortOrder == "desc");
        });
    }

    sort() {
        if (this.isSortedByMeAsc) {
            this.mfTable.setSort(this.sortBy, "desc");
        } else {
            this.mfTable.setSort(this.sortBy, "asc");
        }
    }
}